import { Alert, Button, Input, Select } from 'antd'
import { CONTRACT_TEMPLATE_TYPES } from '@/features/contract/index.ts'
import type { OrderContractDraft } from './order-contract-workspace.tsx'

export function OrderContractFields({
  draft,
  templates,
  orderType,
  disabled,
  loading,
  onChange,
  onLoad,
  onRemove
}: {
  draft: OrderContractDraft
  templates: { id: number; name: string; type: string }[]
  orderType: 'rental' | 'service'
  disabled: boolean
  loading: boolean
  onChange: (patch: Partial<OrderContractDraft>) => void
  onLoad: (id: number) => void
  onRemove: () => void
}) {
  return (
    <aside className="border-border border-b p-4 lg:overflow-y-auto lg:border-r lg:border-b-0">
      <label htmlFor="order-contract-type" className="mb-1 block text-sm font-medium">
        合同类型
      </label>
      <Select
        id="order-contract-type"
        className="w-full"
        value={draft.contractType}
        disabled={disabled || Boolean(draft.sourceDocumentId)}
        options={Object.entries(CONTRACT_TEMPLATE_TYPES)
          .filter(([value]) =>
            orderType === 'service' ? ['service', 'supplement', 'other'].includes(value) : value !== 'service'
          )
          .map(([value, item]) => ({ value, label: item.label }))}
        onChange={(contractType) =>
          onChange({
            contractType,
            templateId: undefined,
            templateVersionId: undefined,
            content: null,
            unresolved: [],
            revision: draft.revision + 1
          })
        }
      />
      <label htmlFor="order-contract-template" className="mt-4 mb-1 block text-sm font-medium">
        合同模板
      </label>
      <Select
        id="order-contract-template"
        className="w-full"
        value={draft.templateId}
        placeholder="选择已发布模板"
        disabled={disabled || Boolean(draft.sourceDocumentId)}
        options={templates
          .filter((template) => template.type === draft.contractType)
          .map((template) => ({ value: template.id, label: template.name }))}
        onChange={onLoad}
      />
      <label htmlFor="order-contract-party" className="mt-4 mb-1 block text-sm font-medium">
        签约名称
      </label>
      <Input
        id="order-contract-party"
        value={draft.partyName}
        maxLength={255}
        disabled={disabled}
        onChange={(event) =>
          onChange({
            partyName: event.target.value,
            ...(!draft.sourceDocumentId ? { templateVersionId: undefined } : {})
          })
        }
      />
      <label htmlFor="order-contract-title" className="mt-4 mb-1 block text-sm font-medium">
        合同名称
      </label>
      <Input
        id="order-contract-title"
        value={draft.title}
        maxLength={255}
        disabled={disabled}
        onChange={(event) => onChange({ title: event.target.value })}
      />
      {!draft.sourceDocumentId && (
        <Button
          block
          className="mt-3"
          disabled={disabled || !draft.templateId}
          loading={loading}
          onClick={() => draft.templateId && onLoad(draft.templateId)}
        >
          重新按模板填充
        </Button>
      )}
      {!draft.sourceDocumentId && (
        <Button block danger className="mt-3" disabled={disabled} onClick={onRemove}>
          移除此合同
        </Button>
      )}
      {draft.error && <Alert className="mt-4" type="error" title={draft.error} />}
      {draft.unresolved.length > 0 && (
        <Alert
          className="mt-4"
          type="warning"
          title="未匹配字段将以空格填充，可继续保存和打印"
          description={draft.unresolved.join('、')}
        />
      )}
    </aside>
  )
}
